export default
	new Intl.DateTimeFormat('en-NZ', { month: 'long', day: 'numeric', year: 'numeric' })
